export default __webpack_public_path__ + "static/CommercializationReactor-55850d8d4a330a1d9bf231f0817a27bf.png";